import { render, staticRenderFns } from "./RcCustomerInfoForm.vue?vue&type=template&id=58ed5526"
import script from "./RcCustomerInfoForm.vue?vue&type=script&lang=js"
export * from "./RcCustomerInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports